import React, { createContext, useState, useRef } from "react";
const initialState = {
  isExpanded: false,
  setIsExpanded: () => {
  },
  onChange: () => {
  },
  selectedValue: "",
  menuId: "",
  registerOption: () => {
  },
  options: {
    current: {
      options: [],
      disabledOptions: []
    }
  },
  isMultiselect: false,
  selectedValues: [],
  filteredOptions: [],
  setFilteredOptions: () => {
  }
};
export const SelectContext = createContext(initialState);
export const SelectProvider = ({
  isMultiselect,
  onChange,
  menuId,
  selectedValue,
  selectedValues,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const options = useRef({
    options: [],
    disabledOptions: []
  });
  const registerOption = (value, disabled) => {
    if (options.current.options.includes(value))
      return;
    options.current = {
      options: [...options.current.options, value],
      disabledOptions: disabled ? [...options.current.disabledOptions, value] : options.current.disabledOptions
    };
    setFilteredOptions(options.current.options);
  };
  return /* @__PURE__ */ React.createElement(SelectContext.Provider, {
    value: {
      isExpanded,
      onChange,
      setIsExpanded,
      selectedValue,
      selectedValues,
      menuId,
      registerOption,
      options,
      isMultiselect,
      filteredOptions,
      setFilteredOptions
    }
  }, children);
};
